/**
 * Enumeration for the driver roles.
 *
 * @readonly
 * @enum {string}
 */
export const DriverRoles = Object.freeze({
    CO_DRIVER: 'CO_DRIVER',
    DRIVER: 'DRIVER',
    WORKER: 'WORKER'
})
